import { httpGet, httpPostFile } from '../../../../utils/api.utils';
import { actions } from 'react-redux-form';
import { batch } from 'react-redux';

import {
    setLocationSiteError,
    setLocationSiteLoading,
    getLocationCountryList,
    locationSiteModel
} from "../../../../constants/model-reducers/external/inventory/locationsite/locationsite-details.settings"

const defaultState = () => (
    {
        isLoaded: false
        , isDropdownListLoaded: false
        , isError: false
        , dropDownPage: 0
        , isVendorListLoaded: false
        , isServiceListLoaded: false
        , vendorList: []
        , isCountryListLoaded: false
        , countriesList: []
        , serviceList: []
    }
);

const initialState = defaultState();

export const locationSiteInitalState = locationSiteModel;

export const LocationSiteFormActions = {
    getLocationSiteFormDetails: (locationId) => async (dispatch) => {
        var result = await httpGet(`external/inventory/getLocationSiteFormDetails/${locationId ?? 0}`);

        if (result != null) {
            await dispatch(LocationSiteFormActions.getLocationCountryList(1, result?.locationSiteFormDetails?.CountryName ? result?.locationSiteFormDetails?.CountryName : ""));

            batch(() => {
                dispatch(actions.load('locationSiteForm.locationSite.locationSiteId', result.locationSiteFormDetails.LocationSite));
                dispatch(actions.load('locationSiteForm.locationSite.address1', result.locationSiteFormDetails.Address1));
                dispatch(actions.load('locationSiteForm.locationSite.address2', (result?.locationSiteFormDetails?.Address2 && result?.locationSiteFormDetails?.Address2 != "null" )? result?.locationSiteFormDetails?.Address2 : ""));
                dispatch(actions.load('locationSiteForm.locationSite.countryId', result.locationSiteFormDetails.CountryID));
                dispatch(actions.load('locationSiteForm.locationSite.countryName', result.locationSiteFormDetails.CountryName));
                dispatch(actions.load('locationSiteForm.locationSite.countryCode', result.locationSiteFormDetails.CountryCode));
                dispatch(actions.load('locationSiteForm.locationSite.city', result.locationSiteFormDetails.City));
                dispatch(actions.load('locationSiteForm.locationSite.locationState', result.locationSiteFormDetails.LocationState));
                dispatch(actions.load('locationSiteForm.locationSite.zip', result.locationSiteFormDetails.Zip));
                dispatch(actions.load('locationSiteForm.locationSite.locationType', (result?.locationSiteFormDetails?.LocationType && result?.locationSiteFormDetails?.LocationType !="null")? result?.locationSiteFormDetails?.LocationType : ""));

            });
        }
    },
    getLocationCountryList: (page = 1, searchString = '') => async (dispatch, getState) => {

        if (getState().isCountryListLoaded) return;

        const pageSize = 15;

        dispatch({
            type: getLocationCountryList,
            isCountryListLoaded: false
        });

        var url = `external/inventory/fetchCountries/${page}/${pageSize}`;

        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getLocationCountryList,
                isCountryListLoaded: true,
                countriesList: res?.countries?.length > 0 ? res?.countries : [],
                hasMoreData: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getLocationCountryList,
                isVendorListLoaded: false,
                countriesList: [],
                isError: true
            });
        }
    },

    getSelectedCountryCode: (countryId, countryName) => async (dispatch) => {
        dispatch(actions.setErrors('locationSiteForm.locationSite.countryId', false));
        var res = await httpGet('external/inventory/getSelectedCountryCode' + '/' + countryId);
        if (res != null) {
            dispatch(actions.change('locationSiteForm.locationSite.countryCode', res));
            dispatch(actions.change('locationSiteForm.locationSite.countryName', countryName));
        }
        else {
            dispatch({
                type: setLocationSiteError,
                isError: true
            });
        }
    },

    saveLocationSite: (locationId, validate) => async (dispatch, state) => {
        const { locationSite } = state().form.locationSiteForm

        try {
            var formData = new FormData();

            formData.append("LocationID", locationId);
            formData.append("Validate", validate);
            formData.append("LocationSite", locationSite.locationSiteId);
            formData.append("Address1", locationSite.address1);
            formData.append("Address2", locationSite.address2);
            formData.append("City", locationSite.city);
            formData.append("LocationState", locationSite.locationState);
            formData.append("Zip", locationSite.zip);
            formData.append("LocationType", locationSite.locationType);
            formData.append("CountryID", locationSite.countryId);
            formData.append("CountryName", locationSite.countryName);
            formData.append("CountryCode", locationSite.countryCode);
            
            var result = await httpPostFile('external/inventory/saveLocation', formData);

            if (result.isExist) {
                dispatch(actions.setErrors('locationSiteForm.locationSite.locationSiteId', true));
                dispatch(actions.setErrors('locationSiteForm.locationSite.address1', true));
                dispatch(actions.setErrors('locationSiteForm.locationSite.city', true));
                dispatch(actions.setErrors('locationSiteForm.locationSite.locationState', true));
                dispatch(actions.setErrors('locationSiteForm.locationSite.zip', true));
                dispatch(actions.setErrors('locationSiteForm.locationSite.countryId', true));
            }
            else {
                dispatch(actions.setErrors('locationSiteForm.locationSite.locationSiteId', false));
                dispatch(actions.setErrors('locationSiteForm.locationSite.address1', false));
                dispatch(actions.setErrors('locationSiteForm.locationSite.city', false));
                dispatch(actions.setErrors('locationSiteForm.locationSite.locationState', false));
                dispatch(actions.setErrors('locationSiteForm.locationSite.zip', false));
                dispatch(actions.setErrors('locationSiteForm.locationSite.countryId', false));
            }
        }
        catch (e) {
            return e;
        }
        return result;
    },

    resetLocationForm: () => (dispatch) => {
        dispatch(actions.reset('locationSiteForm'));
        dispatch(actions.reset('locationSiteForm.locationSite'));
    }
}

export const reducer = (state, action) => {
    state = state || initialState
    switch (action.type) {

        case setLocationSiteLoading:
        return {
            ...state,
            isDropdownListLoaded: action.isDropdownListLoaded
        }

        case getLocationCountryList:
            return {
                ...state,
                countriesList: action.page === 1 ? action.countriesList ?? [] : [...state.countriesList, ...action.countriesList ?? []],
                hasMoreCountry: action.hasMoreData,
                isCountryListLoaded: action.isCountryListLoaded,
                countryListPage: action.page
            }

        default:
            return state;
    }
}